/**
 * Call directly from a user click. Returns false when the browser blocks the tab.
 * The blob URL belongs to this preview and stays valid until its tab closes.
 */
export const previewFile = (file: File): boolean => {
  // noopener makes window.open return null even on success. Open only a blank
  // document, then sever its opener before navigating to any attachment content.
  const previewWindow = window.open("about:blank", "_blank");
  if (!previewWindow) return false;

  let blobUrl: string | undefined;
  try {
    previewWindow.opener = null;
    const url = URL.createObjectURL(file);
    blobUrl = url;
    previewWindow.location.replace(url);

    // An unload listener on the initial blank document fires during navigation,
    // too early to revoke the URL. Checking closed also works for PDF viewers.
    const cleanupInterval = window.setInterval(() => {
      if (previewWindow.closed) {
        URL.revokeObjectURL(url);
        window.clearInterval(cleanupInterval);
      }
    }, 1000);
    return true;
  } catch (error) {
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    previewWindow.close();
    throw error;
  }
};
